import React, { useEffect, useState } from 'react';
import { BoletoPage } from '../pages/boleto/boleto.page';
import { useLocation } from 'react-router-dom';
import { Sell } from '../../common/types/venda';
import { Checkout } from '../../common/types/checkout';
import { BoletoPageSkeleton } from '../molecules/boleto-skeleton/boleto-skeleton.molecule';

export const BoletoTemplate: React.FC = () => {
  const location = useLocation();
  const [venda, setVenda] = useState<Sell>({} as Sell);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [checkout, setCheckout] = useState<Checkout>({} as Checkout);
  useEffect(() => {
    if (!location?.state) {
      window.location.href = 'https://vendepay.com.br';
    } else {
      setVenda(location?.state?.purchase?.data);
      setCheckout(location?.state?.checkout);
      setIsLoading(false);
    }
  }, [location.state]);

  if (isLoading) {
    return <BoletoPageSkeleton />;
  }

  return <BoletoPage venda={venda} checkout={checkout} />;
};
